module.exports = __webpack_public_path__ + "static/media/01.9d95648d.png";